import http from "./http";

// GET ALL UPI
export const getUpiList = async () => {
  const res = await http.post("live_working_logic/manage_upi", {
    action: "list",
  });
  return res.data;
};

// ADD UPI
export const addUpi = async (data) => {
  const res = await http.post("live_working_logic/manage_upi", {
    action: "add",
    ...data,
  });
  return res.data;
};

// UPDATE UPI
export const updateUpi = async (id, data) => {
  const res = await http.post("live_working_logic/manage_upi", {
    action: "edit",
    id,
    ...data,
  });
  return res.data;
};

// DELETE UPI
export const deleteUpi = async (id) => {
  const res = await http.post("live_working_logic/manage_upi", {
    action: "delete",
    id,
  });
  return res.data;
};